<!-- <p>
  energy-main works!
</p> -->

<router-outlet></router-outlet>